exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "img {\r\n    width: 1920px;\r\n    height: 250px;\r\n}\r\n\r\n.img-wrapper {\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/img-header/img-header.component.css
// module id = 744
// module chunks = 1